import React from 'react';
import HomeownerPlanWelcome from './HomeownerPlanWelcome';

const client = {
  id: '00000000-0000-4000-8000-000000000001',
  first_name: 'Alex',
  insurance_renewal_date: '2026-10-28',
  insurance_term_months: 12,
};

/**
 * Development screenshot for the homeowner setup questions.
 * Production builds never mount this. Query: ?preview=plan-welcome
 */
export default function PlanWelcomePreview() {
  return (
    <HomeownerPlanWelcome
      client={client}
      onDone={() => {}}
      onLogout={() => {}}
    />
  );
}
